var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaladores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0924 0C11.3731 0.143522 11.5786 0.292201 11.578 0.618778L10.9353 6.16486C11.0663 6.79195 12.0115 6.85383 12.1903 6.21729C12.4355 4.71876 12.4968 3.16264 12.741 1.6687C12.7469 1.6326 12.7272 1.58562 12.7996 1.61255C12.9846 1.68159 13.4669 2.04082 13.6433 2.17546C15.4625 3.56456 16.5958 5.77326 16.7203 7.9662C16.7326 8.18334 16.7559 8.71532 16.7188 8.90525C16.7105 8.94736 16.6982 8.97544 16.6586 8.99893H1.34649C1.3066 8.97544 1.29433 8.94707 1.28636 8.90525C1.24893 8.71475 1.27255 8.18449 1.28482 7.9662C1.42564 5.42319 2.89053 2.9604 5.20551 1.61255C5.29049 1.60223 5.25613 1.61856 5.26411 1.6687C5.50861 3.16264 5.56966 4.71904 5.81478 6.21729C5.99364 6.85383 6.93884 6.79195 7.06983 6.16486L6.42712 0.618778C6.42651 0.291914 6.63205 0.143522 6.91276 0L11.0924 0Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2861V10.9111C0.142961 10.5427 0.430417 10.2519 0.863901 10.1983L17.1025 10.1969C18.2975 10.337 18.3008 11.8539 17.1025 12L0.863901 11.9985C0.430723 11.9449 0.142961 11.6542 0 11.2858L0 11.2861Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaladores);
export default __webpack_public_path__ + "static/media/instaladores.c846208ab32317090a9bd392b51c3739.svg";
export { ForwardRef as ReactComponent };